<div class="row">
  <div class="col-12 text-center mb-3">
    <h2 class="customized-title">No te lo puedes perder</h2>
    <h3 class="customized-title-h4">
      Contamos con el mayor stock de productos a nivel nacional
    </h3>
  </div>
</div>
<div class="hidden lg:block">
  <div class="grid-gallery">
    @for (item of grid_layout; track $index) {
    <div [ngStyle]="item">
      <app-concepto [concepto]="concepto_array[$index]" />
    </div>
    }
  </div>
</div>

<div class="hidden md:block lg:hidden">
  <div class="grid-gallery">
    @for (item of grid_layout; track $index) {
    <div [ngStyle]="item">
      <app-concepto [concepto]="concepto_array[$index]" />
    </div>
    }
  </div>
</div>

<div class="block md:hidden">
  <div class="gallery-tablet">
    @if(grid_layout && grid_layout.length > 0) {
    <owl-carousel-o class="carouselConcepto" [options]="carouselOptions">
      @for (item of grid_layout; track $index) {
      <ng-container class="products-list__item">
        <ng-template carouselSlide>
          <app-concepto-mobile [concepto]="concepto_array[$index]" />
        </ng-template>
      </ng-container>
      }
    </owl-carousel-o>
    }
  </div>
</div>
